import React, { useEffect, useState } from "react";
import { useStoreState } from 'easy-peasy';
import axios from '../../services/axios';
import { Row, Col, Container } from "react-bootstrap";
import HelperMetiers360 from "../../services/HelpersMetiers360";
import DynamicTable from "../widgets/dynamicTable/DynamicTable";
import { Link } from "react-router-dom";


const CheckLinksTabComponent = () => {
    const { apiData :{URLs}} = useStoreState(state => state.actionSlugs);
    const storySlugs = useStoreState(actions => actions.actionSlugs.actionSlugsDispatcher('stories'));

    const [links, setLinks] = useState([]);

    const getUrl = URLs?.checkLinks?.url;

    useEffect(() => {
        if (getUrl) {
            axios.get(getUrl)
                .then((response) => {
                    setLinks(response);
                });
        }
    }, []);

    const sortType = !links?.length ? []:[
        {
            value: 'title', label : 'Titre',
            test : HelperMetiers360.isArrayContainsValue(links, 'title'),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.title, b.title),
            display: (link) => link.title ? <a href={link.url}>{link.title}</a> : '-',
            flatDisplay: (link) => link.title ? link.title : '-',
        },
        {
            value: 'description', label : 'Description',
            test : HelperMetiers360.isArrayContainsValue(links, 'description'),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.description, b.description),
            display: (link) => link.description ? link.description : '-'
        },
        {
            value: 'updatedAt', label: "Mise à jour",
            test : HelperMetiers360.isArrayContainsValue(links, 'updatedAt'),
            method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.updatedAt, b.updatedAt),
            display: (group) => HelperMetiers360.getdisplayDateType(group.updatedAt, 'day')
        },
        {
            value: 'valid', label: "Valide ?",
            test: HelperMetiers360.isArrayContainsValue(links, "urlValid"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.urlValid, b.urlValid),
            display: (link) => link.urlValid ? 
                <i className='fas fa-check' /> 
                : <i className='fas fa-times' /> ,
            flatDisplay: (link) => link.urlValid ? "Oui" : "Non",
        },
        {
            value: 'story', label: "Story associée",
            test: HelperMetiers360.isArrayContainsValue(links, "story"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.story?.name, b.story?.name),
            display: (link) => link.story?.name ?
                storySlugs.readOne && link.story.uniqueId? <Link to={storySlugs.readOne.replace(':uniqueId', link.story.uniqueId)}>{link.story.name}</Link>:link.story.name
                :'-',
            flatDisplay: (link) => link.story?.name ?? '-',
        },
    ]



    return <Container fluid>
        <Row>
            <Col><h2>Liens magic box et liens "custom" associés à des stories</h2></Col>
        </Row>
        <Row>
            <Col>
                {links && links.length > 0 ?
                    <DynamicTable 
                        contentTable={links}
                        contentSort={sortType}
                        valueInitSort="updatedAt"
                        index = 'uniqueId'
                        tableName="linksTable"
                    />
                :<>Pas de liens</>}
            </Col>
        </Row>
    </Container>

}
export default CheckLinksTabComponent;